import { LoaderCircle } from 'lucide-react';
import * as React from 'react';

import { cn } from '@/src/lib/utils';

export function Spinner({ className, ...props }: React.ComponentProps<typeof LoaderCircle>) {
  return (
    <LoaderCircle
      aria-hidden="true"
      className={cn('size-4 animate-spin', className)}
      {...props}
    />
  );
}
